/*
** 公共底部有个反馈
*/

$('.module-footer [node-type="feedback"]').click(function () {
    Event.trigger('feedback-dialog_show', 'feedback', {
        cityId: $('.module-right-toolbar').attr('data-cityid'),
        source: 1
    });
});



// WEBPACK FOOTER //
// ./src/page/footer.js